import React, { useState } from 'react';
import ProductSearchDropdown from './ProductSearchDropdown';
import QtyStepper from './QtyStepper';
import { TrashIcon } from './ActionIcons';

/**
 * Inline-конструктор сборного букета внутри админ-модалки заказа.
 * Не модалка — компактный блок «Сборный букет N» с собственным поиском стеблей,
 * счётчиком «−/+» (QtyStepper — тот же, что у остальных позиций заказа) и
 * textarea для заметки флористу. Стиль — в палитре бренда (зелёный).
 */
function AssemblyGroupBuilder({
  sequenceNo,
  items,
  floristNotes,
  selectedDate,
  onAddStem,
  onRemoveStem,
  onChangeQty,
  onChangeNotes,
  onRemoveGroup,
}) {
  const [showSearch, setShowSearch] = useState(false);
  const [notesOpen, setNotesOpen] = useState(Boolean(floristNotes));

  return (
    <div style={{
      border: '1px solid #C8DAD3',
      background: '#F1F6F4',
      '--ch': '8px', '--stroke': '#C8DAD3',
      padding: 12,
      marginBottom: 10,
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <div style={{ fontWeight: 600, color: '#1C3D2E', fontSize: 14 }}>
          Сборный букет {sequenceNo}
        </div>
        {/* Удаление — общая иконка-корзина .btn-icon.is-danger, как у позиций заказа (UX-аудит 25.10) */}
        <button
          type="button"
          className="btn-icon is-danger"
          onClick={onRemoveGroup}
          title="Удалить группу"
          aria-label="Удалить группу"
        >
          <TrashIcon />
        </button>
      </div>

      {/* Items list */}
      {items.length === 0 ? (
        <div style={{ color: '#5E6561', fontSize: 12, fontStyle: 'italic', marginBottom: 8 }}>
          Добавьте стебли в эту группу
        </div>
      ) : (
        <div style={{ marginBottom: 8 }}>
          {items.map((it, idx) => (
            <div key={`${it.product_id}-${idx}`} style={{
              display: 'flex', alignItems: 'center', gap: 8,
              padding: '4px 0', fontSize: 13,
            }}>
              <div style={{ flex: 1 }}>{it.product_name}</div>
              <div style={{ color: '#5E6561', fontSize: 12 }}>{it.price} ₽</div>
              <QtyStepper value={it.quantity} min={1} onChange={q => onChangeQty(idx, q)} />
              <button
                type="button"
                className="btn-icon is-danger"
                onClick={() => onRemoveStem(idx)}
                title="Убрать"
                aria-label="Убрать"
                style={{ flexShrink: 0 }}
              >
                <TrashIcon />
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Add stem — ссылка-действие .btn-link, как «+ Добавить стебли» в заказе (UX-аудит 25.10) */}
      {showSearch ? (
        <ProductSearchDropdown
          onSelect={(product) => {
            onAddStem({
              product_id: product.id,
              product_name: product.name,
              price: product.price,
              quantity: 1,
            });
            setShowSearch(false);
          }}
          onClose={() => setShowSearch(false)}
          excludeIds={items.map(it => it.product_id)}
          hideOutOfStock={false}
          selectedDate={selectedDate}
        />
      ) : (
        <button
          type="button"
          className="btn-link"
          onClick={() => setShowSearch(true)}
          style={{ fontSize: 13 }}
        >+ Добавить стебель</button>
      )}

      {/* Florist notes */}
      <div style={{ marginTop: 10 }}>
        {notesOpen ? (
          <textarea
            value={floristNotes || ''}
            onChange={e => onChangeNotes(e.target.value)}
            placeholder="Заметка флористу (опц.): «Бант розовый, обернуть в крафт»"
            rows={2}
            style={{
              width: '100%', boxSizing: 'border-box',
              padding: 6, fontSize: 12,
              border: '1px solid #D8DDDA', '--ch': '5px', '--stroke': '#D8DDDA',
              fontFamily: 'inherit', resize: 'vertical',
            }}
          />
        ) : (
          <button
            type="button"
            className="btn-link"
            onClick={() => setNotesOpen(true)}
            style={{ fontSize: 11 }}
          >+ Добавить заметку флористу</button>
        )}
      </div>
    </div>
  );
}

export default AssemblyGroupBuilder;
